import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const CancellationPolicyPage = () => {
  return (
    <div data-testid="cancellation-policy-page" className="min-h-screen bg-[#FAFAF8]">
      <Header />
      <main>
        {/* Hero */}
        <section className="bg-[#2D5A27] py-16 md:py-20">
          <div className="container mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
            <h1
              data-testid="cancellation-policy-headline"
              className="font-heading text-3xl md:text-4xl lg:text-5xl text-white font-bold"
            >
              Cancellation Policy
            </h1>
            <p className="text-white/80 mt-4">Last updated: December 2025</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-12 md:py-16">
          <div className="container mx-auto max-w-4xl px-4 md:px-6 lg:px-8">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
              <div className="prose prose-lg max-w-none text-[#4B5563]">
                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  1. Cancellation of Services
                </h2>
                <p className="mb-6">
                  We understand that plans can change. This policy outlines our cancellation terms to ensure fair treatment for both our clients and our team.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  2. Scheduled Maintenance Services
                </h2>
                <p className="mb-4">For regular maintenance services (lawn mowing, trimming, etc.):</p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li><strong>48+ hours notice:</strong> No cancellation fee</li>
                  <li><strong>24-48 hours notice:</strong> 25% of service fee may apply</li>
                  <li><strong>Less than 24 hours notice:</strong> 50% of service fee may apply</li>
                  <li><strong>No-show/no notice:</strong> Full service fee may be charged</li>
                </ul>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  3. Project-Based Services
                </h2>
                <p className="mb-4">For landscaping projects and installations:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li><strong>Before deposit:</strong> Cancellation at no charge</li>
                  <li><strong>After deposit, before work begins:</strong> Deposit may be partially or fully forfeited depending on materials ordered or work scheduled</li>
                  <li><strong>After work has begun:</strong> Payment required for all completed work and materials used</li>
                </ul>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  4. Weather-Related Cancellations
                </h2>
                <p className="mb-6">
                  When services are cancelled or postponed due to weather conditions, no cancellation fee applies. We will reschedule at the earliest mutually convenient time. For safety reasons, we do not perform services during severe weather conditions.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  5. Rescheduling
                </h2>
                <p className="mb-6">
                  Rescheduling requests made at least 24 hours in advance are generally accommodated without penalty, subject to availability. We appreciate as much notice as possible to allow us to efficiently schedule our team.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  6. How to Cancel or Reschedule
                </h2>
                <p className="mb-4">To cancel or reschedule a service, please contact us:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li><strong>Phone:</strong> +1-771-1871-113 (fastest response)</li>
                  <li><strong>Email:</strong> info@casacurate.store</li>
                </ul>
                <p className="mb-6">
                  Please include your name, scheduled service date, and whether you wish to cancel or reschedule.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  7. Refund Policy
                </h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li>Refunds for cancelled services will be processed within 7-10 business days.</li>
                  <li>Deposits are non-refundable once materials have been ordered or significant scheduling has occurred.</li>
                  <li>Partial refunds may be issued at our discretion based on work completed and materials used.</li>
                </ul>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  8. Service Termination by CasaCurate Store
                </h2>
                <p className="mb-6">
                  We reserve the right to cancel or terminate services if: property access is not provided as agreed, unsafe conditions are present, payment terms are violated, or there is abusive behavior toward our staff.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  9. Contact Us
                </h2>
                <p className="mb-4">
                  For questions about this Cancellation Policy, please contact us:
                </p>
                <p className="mb-2"><strong>CasaCurate Store</strong></p>
                <p className="mb-2">1513 Sunset Boulevard, Los Angeles, CA 90027</p>
                <p className="mb-2">Phone: +1-771-1871-113</p>
                <p>Email: info@casacurate.store</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CancellationPolicyPage;
